// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsGearSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.428 2.675a3 3 0 0 0 4.182 1.453c.19-.102.424-.105.592.028.477.377.922.8 1.328 1.265.156.179.15.442.024.643a2.996 2.996 0 0 0-.21 2.773 2.996 2.996 0 0 0 2.157 1.754c.233.047.429.223.451.46.059.614.06 1.228.005 1.833-.02.214-.182.382-.386.45a3 3 0 0 0-1.704 4.278c.102.188.105.422-.029.59-.377.478-.799.923-1.264 1.329-.179.156-.442.149-.644.023a2.996 2.996 0 0 0-2.772-.21 2.996 2.996 0 0 0-1.754 2.158c-.048.232-.223.428-.46.45a9.933 9.933 0 0 1-1.833.006c-.214-.02-.382-.183-.45-.387a3 3 0 0 0-4.278-1.704c-.188.102-.423.105-.591-.028a9.937 9.937 0 0 1-1.328-1.265c-.156-.179-.15-.442-.024-.643a2.996 2.996 0 0 0 .21-2.773 2.996 2.996 0 0 0-2.157-1.754c-.233-.047-.429-.223-.451-.46a9.939 9.939 0 0 1-.005-1.833c.02-.214.182-.382.386-.45a3 3 0 0 0 1.704-4.278c-.102-.188-.104-.422.029-.59.377-.478.8-.923 1.264-1.329.18-.156.442-.149.644-.023a2.996 2.996 0 0 0 2.772.21 2.996 2.996 0 0 0 1.754-2.157c.048-.233.223-.43.46-.452a9.939 9.939 0 0 1 1.834-.004c.214.019.382.182.449.386.028.084.06.168.095.251zm2.243 7.742a3.999 3.999 0 1 0-7.347 3.161 3.999 3.999 0 0 0 7.347-3.161z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsGearSolid;
